/* ============================================================
   AQ · La feuille, le moteur du patron des menus du téléphone (lot 13,
   2026-11-02, maquettes approuvées par Félix). Compagnon d'aq-feuille.css,
   chargé sur toutes les pages par sections/aq-feuille.liquid.

   Une feuille monte du bas sur un voile, se ferme par le bouton rond, le
   voile, la touche d'échappement et un glissement vers le bas ; le défilement
   de la page est verrouillé, le focus reste dans la feuille et revient à la
   commande qui l'a ouverte. Une seule feuille ouverte à la fois.

   API
     AQFeuille.creer({ id, titre, titreHtml, classe, corps, pied, surOuvrir, surFermer })
       -> { el, corps, pied, tete, ouvrir(declencheur), fermer(), titre(texte|noeud), ouverte() }
     AQFeuille.attacher(el)   une feuille rendue par le snippet aq-feuille (data-aqf)
     AQFeuille.mobile()       vrai sous 750 px
     AQFeuille.reglage(nom)   un réglage de la section (data-aqf-<nom>)
     AQFeuille.actif(nom)     vrai quand la conversion <nom> est cochée dans la section
     Constructeurs de rangées : rang, choix, lien, etiquette, pilule, bouton, champ, pastille, groupe, vide
   Les libellés se posent en texte, jamais en HTML, sauf les icônes de trait.
   ============================================================ */
(function () {
  'use strict';
  if (window.AQFeuille) return;

  var ICO = {
    /* la flèche ↗ du snippet aq-grille-icone, source unique */
    fleche: '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 13 13 3M5 3h8v8"/></svg>',
    chevron: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7.5 4.5 13 10l-5.5 5.5"/></svg>',
    gauche: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 6l-4 4 4 4"/></svg>',
    coche: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 10.5l4 4 8-9"/></svg>',
    loupe: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="9" cy="9" r="5.5"/><path d="M13.2 13.2 17 17"/></svg>',
    plus: '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M10 4v12M4 10h12"/></svg>'
  };
  var MQ = window.matchMedia ? window.matchMedia('(max-width: 749.98px)') : null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var courante = null, nVerrou = 0, posDefil = 0;

  function el(tag, cls, txt) { var e = document.createElement(tag); if (cls) e.className = cls; if (txt != null) e.textContent = txt; return e; }
  function svg(nom, cls) { var s = el('span', cls); s.innerHTML = ICO[nom] || ''; return s; }
  function noeud(x) { if (x == null) return null; if (typeof x === 'string') { var d = el('div'); d.innerHTML = x; return d; } return x; }
  function reglages() { return document.querySelector('[data-aqf-reglages]'); }
  function reglage(nom) { var r = reglages(); return r ? (r.getAttribute('data-aqf-' + nom) || '') : ''; }
  function actif(nom) { var r = reglages(); if (!r) return true; var v = r.getAttribute('data-aqf-' + nom); return v !== 'false' && v !== '0'; }
  function mobile() { return MQ ? MQ.matches : window.innerWidth < 750; }
  function initiales(nom) { return String(nom || '').trim().split(/\s+/).slice(0, 2).map(function (m) { return m.charAt(0); }).join('').toUpperCase(); }

  /* ---------- le verrou du défilement ---------- */
  function verrou(on) {
    var h = document.documentElement;
    if (on) { if (!nVerrou) { posDefil = window.pageYOffset; h.classList.add('aqf-verrou'); } nVerrou++; }
    else if (nVerrou) { nVerrou--; if (!nVerrou) h.classList.remove('aqf-verrou'); }
  }

  /* ---------- le clavier du système pousse la feuille (visualViewport) ---------- */
  function suivreClavier() {
    var vv = window.visualViewport; if (!vv) return;
    function caler() {
      if (!courante) { document.documentElement.style.removeProperty('--aqf-bas'); return; }
      var bas = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
      document.documentElement.style.setProperty('--aqf-bas', bas + 'px');
    }
    vv.addEventListener('resize', caler); vv.addEventListener('scroll', caler);
    suivreClavier = function () {}; caler();
  }

  /* ---------- la feuille ---------- */
  function Feuille(root, o) {
    var self = this;
    o = o || {};
    this.el = root;
    this.externe = !!o.externe;                   /* une feuille d'un autre composant (AQChoix) : on lui prête le verrou, le piège, le glissement */
    this.pan = o.pan || root.querySelector('.aqf__pan');
    this.tete = o.tete || root.querySelector('.aqf__tete');
    this.h = root.querySelector('.aqf__h');
    this.corps = o.corps || root.querySelector('[data-aqf-corps]') || root.querySelector('.aqf__corps');
    this.pied = root.querySelector('[data-aqf-pied]') || root.querySelector('.aqf__pied');
    this.surOuvrir = o.surOuvrir || null;
    this.surFermer = o.surFermer || null;
    this.declencheur = null;
    this.estOuverte = false;
    this.minuterie = null;
    if (!this.externe) root.querySelectorAll('[data-aqf-fermer]').forEach(function (b) { b.addEventListener('click', function () { self.fermer(); }); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { if (self.externe) return; e.stopPropagation(); self.fermer(); return; }
      if (e.key === 'Tab' && self.estOuverte) self.piege(e);
    });
    if (this.corps) this.corps.addEventListener('scroll', function () { root.classList.toggle('is-defile', self.corps.scrollTop > 0); }, { passive: true });
    this.gestes();
  }
  Feuille.prototype.titre = function (x) {
    if (!this.h) return;
    this.h.textContent = '';
    if (typeof x === 'string') this.h.appendChild(el('span', 'aqf__h-txt', x));
    else if (x) this.h.appendChild(x);
  };
  Feuille.prototype.ouverte = function () { return this.estOuverte; };
  Feuille.prototype.ouvrir = function (declencheur) {
    var self = this;
    if (this.estOuverte) return;
    if (courante && courante !== this) courante.fermer(true);
    courante = this;
    this.declencheur = declencheur || document.activeElement;
    clearTimeout(this.minuterie);
    if (this.externe) { verrou(true); suivreClavier(); this.estOuverte = true; this.el.classList.remove('is-defile'); if (this.corps) this.corps.scrollTop = 0; return; }
    this.el.hidden = false;
    this.el.classList.add('is-visible');
    this.el.classList.remove('is-defile');
    this.corps.scrollTop = 0;
    verrou(true);
    suivreClavier();
    requestAnimationFrame(function () { requestAnimationFrame(function () { self.el.classList.add('is-ouverte'); }); });
    this.estOuverte = true;
    if (this.surOuvrir) this.surOuvrir(this);
    var x = this.el.querySelector('.aqf__x');
    try { if (x) x.focus({ preventScroll: true }); } catch (e) {}
    document.dispatchEvent(new CustomEvent('aqf:ouverte', { detail: { feuille: this } }));
  };
  Feuille.prototype.fermer = function (sansFocus) {
    var self = this;
    if (!this.estOuverte) return;
    this.estOuverte = false;
    if (this.externe) { verrou(false); if (courante === this) courante = null; document.documentElement.style.removeProperty('--aqf-bas'); this.pan.style.transform = ''; this.el.classList.remove('is-glisse'); var dx = this.declencheur; this.declencheur = null; if (this.surFermer) this.surFermer(this); if (!sansFocus && dx && dx.focus && document.contains(dx)) { try { dx.focus({ preventScroll: true }); } catch (e) {} } return; }
    this.el.classList.remove('is-ouverte', 'is-glisse');
    this.pan.style.transform = '';
    verrou(false);
    if (courante === this) courante = null;
    document.documentElement.style.removeProperty('--aqf-bas');
    var d = this.declencheur; this.declencheur = null;
    this.minuterie = setTimeout(function () { self.el.classList.remove('is-visible'); self.el.hidden = true; if (self.surFermer) self.surFermer(self); }, 320);
    if (!sansFocus && d && d.focus && document.contains(d)) { try { d.focus({ preventScroll: true }); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('aqf:fermee', { detail: { feuille: this } }));
  };
  Feuille.prototype.piege = function (e) {
    var f = [].slice.call(this.pan.querySelectorAll(FOCUSABLE)).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
    if (!f.length) { e.preventDefault(); return; }
    var premier = f[0], dernier = f[f.length - 1], a = document.activeElement;
    if (e.shiftKey && (a === premier || !this.pan.contains(a))) { e.preventDefault(); dernier.focus(); }
    else if (!e.shiftKey && (a === dernier || !this.pan.contains(a))) { e.preventDefault(); premier.focus(); }
  };
  /* le glissement vers le bas : depuis la poignée ou le titre toujours, depuis le corps quand il est en haut */
  Feuille.prototype.gestes = function () {
    var self = this, y0 = null, dy = 0, t0 = 0, actifG = false;
    this.pan.addEventListener('touchstart', function (e) {
      if (!e.touches.length) return;
      var t = e.target;
      var tete = self.tete && (self.tete.contains(t) || t.classList.contains('aqf__poignee'));
      if (!tete && (!self.corps.contains(t) || self.corps.scrollTop > 0)) { y0 = null; return; }
      y0 = e.touches[0].clientY; dy = 0; t0 = Date.now(); actifG = false;
    }, { passive: true });
    this.pan.addEventListener('touchmove', function (e) {
      if (y0 == null) return;
      dy = e.touches[0].clientY - y0;
      if (dy <= 0) { if (!actifG) y0 = e.touches[0].clientY; return; }
      if (!actifG && self.corps.scrollTop > 0) { y0 = null; return; }
      actifG = true;
      if (e.cancelable) e.preventDefault();
      self.el.classList.add('is-glisse');
      self.pan.style.transform = 'translateY(' + dy + 'px)';
    }, { passive: false });
    function fin() {
      if (y0 == null) return;
      var vitesse = dy / Math.max(1, Date.now() - t0);
      var h = self.pan.offsetHeight || 1;
      self.el.classList.remove('is-glisse');
      if (actifG && (dy > h * .3 || (dy > 40 && vitesse > .5))) { self.pan.style.transform = ''; self.fermer(); }
      else self.pan.style.transform = '';
      y0 = null; actifG = false;
    }
    this.pan.addEventListener('touchend', fin);
    this.pan.addEventListener('touchcancel', fin);
  };

  function squelette(o) {
    var root = el('div', 'aqf' + (o.classe ? ' ' + o.classe : ''));
    if (o.id) root.id = o.id;
    root.setAttribute('role', 'dialog'); root.setAttribute('aria-modal', 'true'); root.hidden = true;
    var fermerTxt = o.fermer || reglage('fermer') || 'Fermer';
    var voile = el('button', 'aqf__voile'); voile.type = 'button'; voile.setAttribute('data-aqf-fermer', ''); voile.setAttribute('aria-label', fermerTxt); voile.tabIndex = -1;
    var pan = el('div', 'aqf__pan');
    pan.appendChild(el('span', 'aqf__poignee')).setAttribute('aria-hidden', 'true');
    var tete = el('div', 'aqf__tete');
    var h = el('h2', 'aqf__h'); h.id = (o.id || 'aqf-' + Math.random().toString(36).slice(2, 8)) + '-h';
    root.setAttribute('aria-labelledby', h.id);
    var x = el('button', 'aqf__x', '×'); x.type = 'button'; x.setAttribute('data-aqf-fermer', ''); x.setAttribute('aria-label', fermerTxt);
    tete.appendChild(h); tete.appendChild(x); pan.appendChild(tete);
    var corps = el('div', 'aqf__corps'); corps.setAttribute('data-aqf-corps', ''); pan.appendChild(corps);
    if (o.pied) { var pied = el('div', 'aqf__pied'); pied.setAttribute('data-aqf-pied', ''); pan.appendChild(pied); }
    root.appendChild(voile); root.appendChild(pan);
    return root;
  }

  function creer(o) {
    o = o || {};
    var root = squelette(o);
    document.body.appendChild(root);
    var f = new Feuille(root, o);
    if (o.titreNoeud) f.titre(o.titreNoeud); else f.titre(o.titre || '');
    var c = noeud(o.corps); if (c) { if (c.tagName === 'DIV' && !c.className && typeof o.corps === 'string') { while (c.firstChild) f.corps.appendChild(c.firstChild); } else f.corps.appendChild(c); }
    if (o.pied && o.pied !== true && f.pied) { var p = noeud(o.pied); if (typeof o.pied === 'string') { while (p.firstChild) f.pied.appendChild(p.firstChild); } else f.pied.appendChild(p); }
    return f;
  }
  function attacher(root, o) {
    if (!root) return null;
    if (root.__aqf) return root.__aqf;
    if (root.parentNode !== document.body) document.body.appendChild(root);
    var f = new Feuille(root, o || {});
    root.__aqf = f;
    return f;
  }

  /* ---------- les constructeurs de rangées ---------- */
  function etiquette(txt) { return el('span', 'aqf__etq', txt); }
  function rang(etq, contenu) {
    var r = el('div', 'aqf__r');
    if (etq) r.appendChild(etiquette(etq));
    var v = el('div', 'aqf__val');
    (Array.isArray(contenu) ? contenu : [contenu]).forEach(function (c) { if (c == null) return; if (typeof c === 'string') v.appendChild(el('span', 'aqf__16b aqf__une', c)); else v.appendChild(c); });
    r.appendChild(v);
    return r;
  }
  function choix(o) {
    var b = el(o.href ? 'a' : 'button', 'aqf__choix' + (o.on ? ' is-on' : '') + (o.gris ? ' is-gris' : ''));
    if (o.href) b.href = o.href; else b.type = 'button';
    b.setAttribute('role', o.role || 'menuitemradio'); b.setAttribute('aria-checked', o.on ? 'true' : 'false');
    if (o.gris) b.setAttribute('aria-disabled', 'true');
    if (o.avant) b.appendChild(o.avant);
    b.appendChild(el('span', 'aqf__choix-t', o.label));
    if (o.chevron) b.appendChild(svg('chevron', 'aqf__chev'));
    else if (o.on) b.appendChild(svg('coche', 'aqf__coche'));
    if (o.sur) b.addEventListener('click', function (e) { o.sur(e, b); });
    return b;
  }
  function lien(o) {
    var a = el(o.href ? 'a' : 'button', 'aqf__lien');
    if (o.href) { a.href = o.href; if (o.externe) { a.target = '_blank'; a.rel = 'noopener'; } } else a.type = 'button';
    if (o.avant) a.appendChild(o.avant);
    a.appendChild(el('span', 'aqf__lien-t', o.label));
    if (o.fleche !== false) a.appendChild(svg('fleche', 'aqf__fleche'));
    if (o.sur) a.addEventListener('click', function (e) { o.sur(e, a); });
    return a;
  }
  function pilule(o) {
    var p = el(o.href ? 'a' : (o.sur ? 'button' : 'span'), 'aqf__pil' + (o.genre ? ' aqf__pil--' + o.genre : ''));
    if (o.href) { p.href = o.href; if (o.externe) { p.target = '_blank'; p.rel = 'noopener'; } } else if (o.sur) p.type = 'button';
    p.appendChild(document.createTextNode(o.texte));
    if (o.fleche) p.appendChild(svg('fleche'));
    if (o.sur) p.addEventListener('click', function (e) { o.sur(e, p); });
    return p;
  }
  function bouton(o) {
    var b = el(o.href ? 'a' : 'button', 'aqf__btn' + (o.sombre ? ' aqf__btn--sombre' : ''));
    if (o.href) b.href = o.href; else b.type = 'button';
    b.textContent = o.texte;
    if (o.sur) b.addEventListener('click', function (e) { o.sur(e, b); });
    return b;
  }
  function champ(o) {
    var l = el('label', 'aqf__champ');
    l.appendChild(svg('loupe'));
    var i = el('input'); i.type = o.type || 'search'; i.setAttribute('autocomplete', 'off'); i.setAttribute('aria-label', o.label || o.place || ''); if (o.place) i.placeholder = o.place; if (o.maxlength) i.maxLength = o.maxlength;
    if (o.sur) i.addEventListener('input', function () { o.sur(i.value, i); });
    l.appendChild(i); l.input = i;
    return l;
  }
  function pastille(o) {
    var s = el('span', 'aqf__pastille' + (o.petite ? ' aqf__pastille--s' : ''));
    if (o.img) { var im = el('img'); im.src = o.img; im.alt = ''; im.loading = 'lazy'; s.appendChild(im); }
    else if (o.icone) s.innerHTML = ICO[o.icone] || '';
    else s.textContent = o.initiales || initiales(o.nom);
    s.setAttribute('aria-hidden', 'true');
    return s;
  }
  function groupe() { return el('div', 'aqf__grp'); }
  function inter(txt) { return el('div', 'aqf__inter', txt); }
  function vide(txt) { return el('div', 'aqf__vide', txt); }
  function retour(txt, sur) { var b = el('button', 'aqf__retour'); b.type = 'button'; b.innerHTML = ICO.gauche; b.appendChild(document.createTextNode(txt)); if (sur) b.addEventListener('click', sur); return b; }
  function titreAvecPastille(nom, img) { var w = document.createDocumentFragment(); w.appendChild(pastille({ nom: nom, img: img })); w.appendChild(el('span', 'aqf__h-txt', nom)); return w; }

  /* une feuille d'un autre composant : on lui prête le verrou du défilement, le piège du focus, le glissement
     vers le bas et le suivi du clavier ; o.pan, o.tete, o.corps sont ses propres nœuds, o.surFermer ferme chez lui */
  function habiller(root, o) {
    if (root.__aqfHab) return root.__aqfHab;
    o = o || {}; o.externe = true;
    var f = new Feuille(root, o);
    root.__aqfHab = f;
    return f;
  }
  window.AQFeuille = {
    creer: creer, attacher: attacher, habiller: habiller, mobile: mobile, reglage: reglage, actif: actif, icone: function (n) { return ICO[n] || ''; }, svg: svg,
    rang: rang, choix: choix, lien: lien, etiquette: etiquette, pilule: pilule, bouton: bouton, champ: champ, pastille: pastille, groupe: groupe, inter: inter, vide: vide, retour: retour, titreAvecPastille: titreAvecPastille, el: el,
    courante: function () { return courante; }, initiales: initiales
  };
  /* un retour au bureau ferme la feuille ouverte */
  if (MQ && MQ.addEventListener) MQ.addEventListener('change', function () { if (!MQ.matches && courante && courante.el.classList.contains('aqf--tel')) courante.fermer(); });
})();
